module.exports = __webpack_public_path__ + "static/media/logo-redes.b7857da1.png";